import { 
    USER_LOGIN_REQUEST,
    USER_LOGIN_SUCCESS,
    USER_LOGIN_FAIL,
    USER_LOGOUT,

    USER_REGISTER_REQUEST,
    USER_REGISTER_SUCCESS,
    USER_REGISTER_FAIL,

    USER_DETAILS_REQUEST,
    USER_DETAILS_SUCCESS,
    USER_DETAILS_FAIL,
    USER_DETAILS_RESET,

    USER_UPDATE_PROFILE_REQUEST,
    USER_UPDATE_PROFILE_SUCCESS,
    USER_UPDATE_PROFILE_FAIL,

    REGISTER_LICENSE_REQUEST,
    REGISTER_LICENSE_SUCCESS,
    REGISTER_LICENSE_FAIL,

    SUBMIT_EXPERIENCE_REQUEST,
    SUBMIT_EXPERIENCE_SUCCESS,
    SUBMIT_EXPERIENCE_FAIL,

    GET_ALL_USERS_REQUEST,
    GET_ALL_USERS_SUCCESS,
    GET_ALL_USERS_FAIL,

    GET_USER_LOCATION_REQUEST,
    GET_USER_LOCATION_SUCCESS,

    USER_RESET_PASSWORD_REQUEST,
    USER_RESET_PASSWORD_SUCCESS,
    USER_RESET_PASSWORD_FAIL,

    CONFIRM_REGISTRATION_REQUEST,
    CONFIRM_REGISTRATION_SUCCESS,
    CONFIRM_REGISTRATION_FAIL,

} from '../constants/userConstants'
import axios from 'axios'

export const login = (email, password) => async(dispatch) => {
    try {
        dispatch({
            type: USER_LOGIN_REQUEST
        })

        const config = {
            headers:{
                'Content-type': 'application/json'
            }
        }
        
        const {data} = await axios.post(
            process.env.REACT_APP_GOLANGAPI + '/api/users/login',
            {
                'username': email,
                'password': password,
            },
            config
        )

        window.localStorage.setItem('userInfo', JSON.stringify(data))

        dispatch({
            type: USER_LOGIN_SUCCESS,
            payload: data,
        })
    }
    catch(error){
        dispatch({
            type: USER_LOGIN_FAIL,
            payload: error.response && error.response.data
            ? error.response.data
            : error.message,
        })
    }
}

export const logout = () => (dispatch) => {
    window.localStorage.removeItem('userInfo')

    dispatch({ type: USER_LOGOUT })
    dispatch({ type: USER_DETAILS_RESET })
}

export const register = (firstName, lastName, email, password) => async(dispatch) => {
    try {
        dispatch({
            type: USER_REGISTER_REQUEST
        })

        const config = {
            headers:{
                'Content-type': 'application/json',
            },
        }

        const {data} = await axios.post(
            process.env.REACT_APP_GOLANGAPI + '/api/users/register',
            {
                'firstName': firstName,
                'lastName': lastName,
                'email': email,
                'password': password,
            },
            config
        )

        dispatch({
            type: USER_REGISTER_SUCCESS,
            payload: data,
        })
    }
    catch(error){
        dispatch({
            type: USER_REGISTER_FAIL,
            payload: error.response && error.response.data
            ? error.response.data
            : error.message,
        })
    }
}

export const getUserDetails = () => async(dispatch, getState) => {
    try {
        dispatch({
            type: USER_DETAILS_REQUEST
        })

        const { userLogin: { userInfo }} = getState()

        const config = {
            headers:{
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.accessToken}`
            }
        }

        const {data} = await axios.get(
            process.env.REACT_APP_GOLANGAPI + `/api/users/profile`,
            config
        )

        dispatch({
            type: USER_DETAILS_SUCCESS,
            payload: data,
        })
    }
    catch(error){
        dispatch({
            type: USER_DETAILS_FAIL,
            payload: error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
        })
    }
}

export const updateUserProfile = (user) => async(dispatch, getState) => {
    try {
        dispatch({
            type: USER_UPDATE_PROFILE_REQUEST
        })

        const { userLogin: { userInfo }} = getState()

        const config = {
            headers:{
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        const {data} = await axios.put(
            process.env.REACT_APP_GOLANGAPI + `/api/users/profile/update`,
            user,
            config
        )

        dispatch({
            type: USER_UPDATE_PROFILE_SUCCESS,
            payload: data,
        })

        dispatch({ type: USER_DETAILS_RESET })
        
        window.localStorage.setItem('userInfo', JSON.stringify(data))
    }
    catch(error){
        dispatch({
            type: USER_UPDATE_PROFILE_FAIL,
            payload: error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
        })
    }
}

export const submitExperience = (comment) => async(dispatch, getState) => {
    try {
        dispatch({
            type: SUBMIT_EXPERIENCE_REQUEST
        })

        const { userLogin: { userInfo }} = getState()

        const config = {
            headers:{
                'Content-type': 'application/json'
            }
        }

        await axios.post(
            process.env.REACT_APP_GOLANGAPI + '/api/comments',
            {
                'user_id': userInfo ? userInfo.id : -1,
                'comment': comment,
            },
            config
        )

        dispatch({
            type: SUBMIT_EXPERIENCE_SUCCESS,
        })
    }
    catch(error){
        dispatch({
            type: SUBMIT_EXPERIENCE_FAIL,
            payload: error.response && error.response.data
            ? error.response.data
            : error.message,
        })
    }
}

export const getAllUsers = () => async(dispatch) => {
    try {
        dispatch({
            type: GET_ALL_USERS_REQUEST
        })

        const { data } = await axios.get('/api/users')

        dispatch({
            type: GET_ALL_USERS_SUCCESS,
            payload: data,
        })
    }
    catch(error){
        dispatch({
            type: GET_ALL_USERS_FAIL,
            payload: error.response && error.response.data
            ? error.response.data
            : error.message,
        })
    }
}

export const resetPassword = (key, password) => async(dispatch, getState) => {
    try {
        dispatch({
            type: USER_RESET_PASSWORD_REQUEST
        })

        const config = {
            headers:{
                'Content-type': 'application/json',
            }
        }

        const {data} = await axios.post(
            process.env.REACT_APP_GOLANGAPI + `/api/users/password`,
            {
                'key': key,
                'password': password,
            },
            config
        )

        dispatch({
            type: USER_RESET_PASSWORD_SUCCESS,
            payload: data,
        })
    }
    catch(error){
        dispatch({
            type: USER_RESET_PASSWORD_FAIL,
            payload: error.response && error.response.data
            ? error.response.data
            : error.message,
        })
    }
}

export const confirmRegistration = (hash) => async(dispatch) => {    
    try {
        dispatch({
            type: CONFIRM_REGISTRATION_REQUEST
        })

        const config = {
            headers:{
                'Content-type': 'application/json'
            }
        }

        const {data} = await axios.post(
            process.env.REACT_APP_GOLANGAPI + '/api/users/confirm',
            {
                'hash': hash,
            },
            config
        )

        dispatch({
            type: CONFIRM_REGISTRATION_SUCCESS,
            payload: data,
        })
    }
    catch(error){
        dispatch({
            type: CONFIRM_REGISTRATION_FAIL,
            payload: error.response && error.response.data
            ? error.response.data
            : error.message,
        })
    }
}